"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockCompanyPublicProfileData = void 0;
const faker_1 = require("@faker-js/faker");
const Constants_1 = require("../../Constants");
const createMockCompanyPublicProfileData = (overwrites = {}) => {
    return Object.assign({ publicInfo: {
            country: faker_1.faker.address.country(),
            state: faker_1.faker.address.state(),
            industryVertical: faker_1.faker.company.bsBuzz(),
            investmentAmount: faker_1.faker.datatype.number(),
            revenueModel: Constants_1.CompanyRevenueModel.Saas,
            latestPostMoneyValuation: faker_1.faker.datatype.number(),
            totalEquityRaised: 'between_0_and_5_m',
            publicDescription: faker_1.faker.lorem.paragraph(),
            foundedYear: faker_1.faker.date.past().getFullYear().toString(),
            showPreIntroCharts: faker_1.faker.datatype.boolean(),
        } }, overwrites);
};
exports.createMockCompanyPublicProfileData = createMockCompanyPublicProfileData;
//# sourceMappingURL=CompanyPublicProfileData.factory.js.map